import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {
    getAllPrintfulSyncProductVariants,
    searchPrintfulSyncProductVariantsWithSearchCriteria
} from "../../services/printful-sync-product-variants-data.service";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {PRINTFUL_SYNC_PRODUCT_VARIANTS_FIELDS_LIST} from "../../constants/printful-sync-product-variants.constant";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";


const defaultFilterCriteria: any = {};

const PrintfulSyncProductVariantsList = () => {
    const [printfulSyncProductVariantsList, setPrintfulSyncProductVariantsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getPrintfulSyncProductVariantsList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        // const printfulSyncProductVariantsListResult = await getAllPrintfulSyncProductVariants();
        const printfulSyncProductVariantsListResult = await searchPrintfulSyncProductVariantsWithSearchCriteria(searchCriteriaList);

        setPrintfulSyncProductVariantsList(printfulSyncProductVariantsListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getPrintfulSyncProductVariantsList();
    }, [filterCriteria]);

    const refreshPrintfulSyncProductVariantsList = async () => {
        await getPrintfulSyncProductVariantsList();
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Printful Sync Product Variants

                        {printfulSyncProductVariantsList &&
                            <span className={'ml-2'}>({printfulSyncProductVariantsList?.length})</span>
                        }
                    </div>

                    {/*<PrintfulSyncProductVariantsFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/3 flex items-center justify-end">
                    <div className="ml-2">

                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={printfulSyncProductVariantsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Printful Sync Product Variants'}/>

                    {printfulSyncProductVariantsList?.length > 0 &&
                        <div className={'table-container overflow-y-scroll border-y border-gray-400 bg-white'}>
                            <table className="w-full">
                                <thead className="">
                                <tr>
                                    <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                    {PRINTFUL_SYNC_PRODUCT_VARIANTS_FIELDS_LIST?.map((printfulSyncProductVariantsField, rowIndex) => (
                                        <th key={`th-${rowIndex}`}
                                            className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${printfulSyncProductVariantsField?.cssClass}`}>{printfulSyncProductVariantsField?.label}</th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody className="">
                                {printfulSyncProductVariantsList?.map((printfulSyncProductVariants, rowIndex) => (
                                    <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                        <td className="p-2 border border-gray-400 m-auto">
                                            <div className="flex justify-center w-12">
                                                {rowIndex + 1}
                                            </div>
                                        </td>

                                        {PRINTFUL_SYNC_PRODUCT_VARIANTS_FIELDS_LIST?.map((printfulSyncProductVariantsField, columnIndex) => (
                                            <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                                <td className={`p-2 border border-gray-400 m-auto ${printfulSyncProductVariantsField?.cssClass}`}>
                                                    {printfulSyncProductVariantsField?.optionsMap &&
                                                        <>{printfulSyncProductVariantsField?.optionsMap[printfulSyncProductVariants[printfulSyncProductVariantsField?.attribute]]?.name}</>
                                                    }

                                                    {!printfulSyncProductVariantsField?.optionsMap &&
                                                        <>
                                                            {printfulSyncProductVariants[printfulSyncProductVariantsField?.attribute]}

                                                            {printfulSyncProductVariantsField?.secondaryAttribute &&
                                                                <div className={'text-gray-500 text-sm'}>
                                                                    {printfulSyncProductVariants[printfulSyncProductVariantsField?.secondaryAttribute]}
                                                                </div>
                                                            }
                                                        </>
                                                    }
                                                </td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>

            </div>

        </>
    )
}

export default PrintfulSyncProductVariantsList
